// src/pages/LandingPage/Benefits.jsx
import {
    Box,
    Container,
    Heading,
    SimpleGrid,
    Icon,
    Text,
    Stack,
    Flex,
    useColorModeValue
  } from '@chakra-ui/react';
  import { FaPalette, FaRegLightbulb, FaRegGem } from 'react-icons/fa';
  
  const Feature = ({ title, text, icon }) => {
    return (
      <Stack
        bg={useColorModeValue('white', 'gray.800')}
        borderRadius="lg"
        p={8}
        transition="all 0.3s ease"
        _hover={{
          transform: 'translateY(-10px)',
          boxShadow: 'lg',
        }}
      >
        <Flex
          w={16}
          h={16}
          align={'center'}
          justify={'center'}
          color={'white'}
          rounded={'full'}
          bg={useColorModeValue('gray.100', 'gray.700')}
          mb={4}
        >
          <Icon as={icon} w={10} h={10} color="brand.primary" />
        </Flex>
        <Heading as="h3" size="md" color="brand.primary" mb={4}>
          {title}
        </Heading>
        <Text color={useColorModeValue('gray.600', 'gray.400')}>
          {text}
        </Text>
      </Stack>
    );
  };
  
  const Benefits = () => {
    return (
      <Box bg={useColorModeValue('white', 'gray.800')} py={20}>
        <Container maxW={'1200px'}>
          <Heading
            as="h2"
            fontSize={{ base: '3xl', md: '4xl' }}
            textAlign={'center'}
            mb={16}
            color="brand.primary"
          >
            Por que escolher o Draw Your Goods?
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
            <Feature
              icon={FaPalette}
              title={'Sua história em cada traço'}
              text={
                'Transforme momentos especiais em arte personalizada que conta sua história única e proporciona uma experiência significativa.'
              }
            />
            <Feature
              icon={FaRegLightbulb}
              title={'Desconecte e relaxe'}
              text={
                'Encontre calma e paz ao colorir suas próprias memórias, longe das telas digitais e do estresse do dia a dia.'
              }
            />
            <Feature
              icon={FaRegGem}
              title={'Exclusividade garantida'}
              text={
                'Cada desenho é único como a sua história, criado especialmente para você através da nossa tecnologia de IA avançada.'
              }
            />
          </SimpleGrid>
        </Container>
      </Box>
    );
  };
  
  export default Benefits;